function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.188 0h2.624v5.25l-.49 3.265 1.963-2.655 3.712-3.712 1.856 1.856-3.712 3.712-2.653 1.96 3.262-.489H21v2.626h-5.25l-3.261-.49 2.652 1.96 3.713 3.713-1.857 1.856-3.712-3.712-1.962-2.655.49 3.265V21H9.187v-5.25l.49-3.262-1.96 2.652-3.713 3.712-1.856-1.856 3.712-3.712 2.653-1.961-3.263.49H0V9.187h5.25l3.265.49-2.654-1.962-3.713-3.712 1.857-1.856 3.712 3.712 1.96 2.651-.49-3.26V0z",
  fill: "#999"
});

function SvgStarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgStarinline;